require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-sprints-in-tech-a-glimpse-at-how-dev-teams-work-in-the-real-world.json") })
        }
      }, "path---blog-sprints-in-tech-a-glimpse-at-how-dev-teams-work-in-the-real-world");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-sprints-in-tech-a-glimpse-at-how-dev-teams-work-in-the-real-world!./.cache/json/blog-sprints-in-tech-a-glimpse-at-how-dev-teams-work-in-the-real-world.json
// module id = 1063
// module chunks = 231608221292675